import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import OrganizationListTable from 'components/organismos/organization/OrganizationListTable/OrganizationListTable';

import BlockUI from 'components/molecules/BlockUi';
import { useOrganizationList } from './hooks';
import FormContents from 'components/atoms/Form/FormContents';
import { css } from '@emotion/core';
import FormHeader from 'components/templates/FormHeader';

const OrganizationsPage: React.FC = () => {
  const {
    organizationList,
    fetchData,
    noManager,
    toggleNoManager,
    unsetTargetDate,
    setUnsetTargetDate,
    orgStatus,
    setOrgStatus,
    blocking,
  } = useOrganizationList();

  return (
    <SidebarTemplate>
      <BlockUI blocking={blocking}>
      <FormHeader title="組織マスタ"/>
        <FormContents customStyle={css({marginTop:'60px'})}>
        <OrganizationListTable
          organizationList={organizationList}
          fetchData={fetchData}
          noManager={noManager}
          toggleNoManager={toggleNoManager}
          unsetTargetDate={unsetTargetDate}
          setUnsetTargetDate={setUnsetTargetDate}
          orgStatus={orgStatus}
          setOrgStatus={setOrgStatus}
        />
        </FormContents>
      </BlockUI>
    </SidebarTemplate>
  );
};

export default OrganizationsPage;
